skrilla.directive('queryContests', function () {
    return {
        templateUrl: 'directives/queryContests/queryContests.html',
        scope: {
            contests: "=",
            type: "="
        },
        controller: function ($scope, searchService, queryService, paginationService, cacheService) {
            $scope.pageKey = "contests";
            $scope.reset = function () {
                $scope.query = {
                    usd: true,
                    aud: false,
                    skr: false,
                    publishPending: false,
                    publishPublished: false,
                    publishRetracted: false,
                    statePending: false,
                    stateLive: false,
                    stateCompleted: false,
                    stateCancelled: false,
                    stateAwaitingResult: false,
                    contestKindType: $scope.type,
                    limit: 20
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getContests, $scope.pageKey);
            }

            var getContests = function () {
                return searchService.get("contests" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.contests = response.data.result;
                    cacheService.registerObject($scope.type + "Contests", $scope.contests);
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
